import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome';
import { Button, ButtonToolbar } from 'react-bootstrap'
import TyreStore from 'stores/TyreStore'
import FormJsonSchema from "react-jsonschema-form";
import { DEFAULT_SCHEMA, DEFAULT_UI_SCHEMA } from './AssetVehicleGenFormSchema'

const NotificationSystem = require('react-notification-system');

class AssetVehicleGenForm extends Component {
  initialData = {
    added_by: '',
    added_date: '',
    brand: '',
    cost_per_unit: '',
    driver_name: '',
    employee_id: '',
    head_registration_no: '',
    location: '',
    model: '',
    remark: '',
    tail_registration_no: '',
    thumbnail_url: '',
    total_wheel: '',
    vehicle_id: '',
    vehicle_no: '',
    vehicle_registration_no: '',
    vehicle_type: ''
  }      

  constructor(props) {
    super(props)

    this.state = {	 	
      loading:false,
      formData:this.initialData,
      schema:DEFAULT_SCHEMA,
      uiSchema:DEFAULT_UI_SCHEMA,
      fields:{},
      vehicle_id:''
    }
  }

  componentDidMount() {
    
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  onFormChange(e) {
    let {formData} = e
    let newFormData = {
        ...formData
    };   

    let new_state = {
        formData: newFormData,
    };
    this.setState(new_state)
  }

  onSaveClick() {
    let {vehicleId} = this.props
    let {formData} = this.state
    this.setState({loading:true})
    TyreStore.saveAssetVehicleTyre(vehicleId,formData,(result)=>{
        if (result.status==='OK') {
            this.refs.notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message: 'บันทึกรายการสำเร็จ',
                level: 'info',
                position:'tc'
            });
            formData.vehicle_id = result.vehicle_id
            this.setState({loading:false,formData:formData})
            if (this.props.onAfterSave!==undefined)
                this.props.onAfterSave(formData)
        }
    },()=>{
        this.setState({loading:false})
        this.refs.notificationSystem.addNotification({
            title:'แจ้งเตือน',
            message: 'บันทึกรายการไม่สำเร็จ',
            level: 'error',
            position:'tc'
        });
    })
  }

  onClose() {
    if (this.props.onClose!==undefined)
        this.props.onClose()
  }

  onSetFormData(formData) {
      this.setState({formData:formData})
  }

  renderGenForm() {
    let {schema,uiSchema,fields,formData} = this.state
    return(
        <FormJsonSchema
            schema={schema}
            uiSchema={uiSchema}
            fields={fields}
            formData={formData}
            onChange={this.onFormChange.bind(this)}
        >
            <div></div>
        </FormJsonSchema>            
    )
  }

  render() {
    let {onClose} = this.props
    let {loading} = this.state
    return(
    	<div>
            <div>
                <Box loading={loading}>
                    <Box.Body>
                        {this.renderGenForm()}
                    </Box.Body>   
                    <Box.Footer>
                        <ButtonToolbar className='pull-right'>    
                            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
                            {onClose!==undefined?<Button onClick={this.onClose.bind(this)}><FontAwesome name='close' />&nbsp;ปิด</Button>:''}
                        </ButtonToolbar>
                    </Box.Footer>             
                </Box>
            </div>	
            <NotificationSystem ref="notificationSystem" /> 		      
	    </div>  
    )
  }
}

AssetVehicleGenForm.defaultProps = {
  
}

export default AssetVehicleGenForm;


// WEBPACK FOOTER //
// ./src/view/tyre/AssetVehicleGenForm.js